import React, { useState, useRef, useEffect, useCallback } from "react";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import { useSelector } from "react-redux";
import MultiCharts from "./multiline-graphs";
import SaaTaaChart from "../../Components/TableWithFilters/saa-taa-graph";
import { debounce } from "lodash";
import { useToast } from "../../Utils/toastContext";
import { useNavigate, useLocation } from "react-router-dom";

const CustomGraph = ({ stockCode, totalPercentage, componentName }) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const [selectedFilter, setSelectedFilter] = useState("10Y");
  const [selectedStocks, setSelectedStocks] = useState(["ALL"]);
  const [selectedStock, setSelectedStock] = useState("ALL");
  const [graphData, setGraphdata] = useState([]);
  const [combineData, setCombinedata] = useState([]);

  const [taaGraphData, setTaaGraphData] = useState({});

  const [years, setYears] = useState([]);
  const [retrunedpercentages, setretrunedpercentages] = useState([]);
  const [searchStock, setSearchStock] = useState("");
  const investment_id = useSelector((state) => state.investment.investmentId);
  const [isLoadingGraph, setIsLoadingGraph] = useState(false);
  const { showToast } = useToast();
  const buttonStock = useRef(null);

  const [stockPrices, setStockprices] = useState(
    Number(totalPercentage) > 100 ? [] : []
  );
  const handleStockListChange = (option) => {
    setSelectedStocks((prev) => {
      if (option.value === "ALL") {
        setSelectedStock("ALL");
        // If "ALL" is selected, replace the array with only "ALL"
        return prev.includes("ALL") ? [] : ["ALL"];
      } else {
        setSelectedStock("");
        // If a regular option is selected
        const updatedAccounts = prev.includes(option.value)
          ? prev.filter((item) => item !== option.value) // Remove if already selected
          : [...prev.filter((item) => item !== "ALL"), option.value]; // Add and remove "ALL" if necessary
        return updatedAccounts;
      }
    });
    hasGenerated.current = false;
  };
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const dropdownRef = useRef();
  const Allstock = [];
  Allstock.push({
    value: "ALL",
    label: "ALL",
  });
  const filteredStock = [
    ...new Map(
      stockCode
        .filter((item) => item.stockId !== 93) // Exclude stockId 93
        .map((item) => [item.stockId, item])
    ).values(),
  ];

  filteredStock.forEach((stock) => {
    Allstock.push({
      value: stock.stockId,
      label: stock.code,
    });
  });

  const availableStocks = ["ALL", "AAA", "AQLT", "DJRES"];

  const filterGraphData = (filter) => {
    const today = new Date();
    let filteredData;

    if (filter === "10Y") {
      filteredData = graphData.filter((item) => {
        const itemDate = new Date(item.date);
        return today.getFullYear() - itemDate.getFullYear() <= 10;
      });
    } else if (filter === "5Y") {
      filteredData = graphData.filter((item) => {
        const itemDate = new Date(item.date);
        return today.getFullYear() - itemDate.getFullYear() <= 5;
      });
    } else if (filter === "1Y") {
      filteredData = graphData.filter((item) => {
        const itemDate = new Date(item.date);
        return today.getFullYear() - itemDate.getFullYear() <= 1;
      });
    } else if (filter === "3M") {
      filteredData = graphData.filter((item) => {
        const itemDate = new Date(item.date);
        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);

        return itemDate >= threeMonthsAgo && itemDate <= today;
      });
    } else if (filter === "1M") {
      filteredData = graphData.filter((item) => {
        const itemDate = new Date(item.date);
        return (
          today.getFullYear() === itemDate.getFullYear() &&
          today.getMonth() - itemDate.getMonth() <= 1
        );
      });
    }
    return filteredData;
  };

  // const labels = filterGraphData(selectedFilter).map((item) =>
  //   new Date(item.date).toLocaleDateString("en-GB", {
  //     year: "numeric",
  //     month: "short",
  //   })
  // );
  const handleStockChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setSelectedStock(selectedOption.value);
    setIsOpen(!isOpen);
  };
  // const filteredData = filterGraphData(selectedFilter).map((item) => {
  //   if (selectedStock === "ALL") {
  //     return item.stock_prices.reduce((sum, stock) => sum + stock.price, 0);
  //   } else {
  //     return item.stock_prices.find(
  //       (stock) => stock.stock_asx === selectedStock
  //     )?.price;
  //   }
  // });

  const GenerateGraphAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/investment-portfolio/historic-performance`;
    let Allids = [];
    let ids = [];
    let allocations = [];
    if (selectedStock != "ALL") {
      Allids = [
        ...new Set(
          stockCode
            .filter((item) => item.stockId !== 93)
            .map((item) => item.stockId)
        ),
      ];
      allocations = stockCode
        .filter((item) => item.stockId !== 93)
        .map((item) => Number(item.allocation));
      ids = selectedStocks;
    } else {
      Allids = [
        ...new Set(
          stockCode
            .filter((item) => item.stockId !== 93)
            .map((item) => item.stockId)
        ),
      ];
      allocations = stockCode
        .filter((item) => item.stockId !== 93)
        .map((item) => Number(item.allocation));

      ids = [];
    }

    const bodyData = {
      stock_ids_for_graph: ids,
      all_stock_ids: Allids,
      time_interval: selectedFilter,
      allocations: allocations,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const GenerateGraph = async () => {
    setIsLoadingGraph(true);
    try {
      const response = await GenerateGraphAPI();
      setretrunedpercentages([]);

      if (response.status == 200) {
        setGraphdata(response.data.graph_data);
        setCombinedata(response.data.combined_index_graph);
        setYears(response.data.years);
        let percentageReturns = response.data.percentage_returns.map((item) =>
          parseFloat(item.percentage_return.toFixed(2))
        );
        setretrunedpercentages(percentageReturns);
        percentageReturns = [];
        let stockPriceNews = response.data.graph_data.map((item) =>
          item.stock_prices && item.stock_prices.length > 0
            ? item.stock_prices[0].price
            : 0
        );
        setStockprices(stockPriceNews);
      } else {
        showToast(response.message, "error");
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setIsLoadingGraph(false);
    }
  };
  const GenerateGraphSaaTaaAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/investment-portfolio/taa/historic-performance`;
    const bodyData = {
      portfolio_id: investment_id,
      time_interval: selectedFilter,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const GenerateGraphSaaTaa = useCallback(
    debounce(async () => {
      setIsLoadingGraph(true);
      let toastMessage = null;
      try {
        const response = await GenerateGraphSaaTaaAPI();
        if (response.status == 200) {
          setTaaGraphData(response.data);
        } else {
          toastMessage = { message: response.message, type: "error" };
          setTaaGraphData({});
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
        setTaaGraphData({});
      } finally {
        // Show toast after loading is false
        setIsLoadingGraph(false);
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 100),
    [selectedFilter] // Dependencies
  );
  const hasGenerated = useRef(false);

  useEffect(() => {
    if (componentName !== "saa-taa" && !hasGenerated.current) {
      GenerateGraph();
      hasGenerated.current = true;
    }
  }, [selectedFilter, selectedStocks, stockCode]);

  useEffect(() => {
    if (componentName == "saa-taa") {
      GenerateGraphSaaTaa();
    }
  }, [investment_id, selectedFilter]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (buttonStock.current && !buttonStock.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  return (
    <div className="py-6 px-4 bg-white">
      <div className="mb-4 flex flex-wrap justify-between items-center">
        <span>
          <h3 className="text-lg font-semibold text-gray-800 w-full md:w-auto">
            Historical Performance
          </h3>

          <p className="text-sm font-normal text-[#868686] w-full md:w-auto">
            Total Allocation should be 100% to generate the Historical
            Performance Graph
          </p>
        </span>{" "}
        {componentName != "saa-taa" && (
          <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-2 mt-2 md:mt-0">
            {/* Generate Graph Button */}
            {/* <button
              onClick={GenerateGraph}
              className="bg-white text-black pl-2 pr-6 py-1 h-10 whitespace-nowrap border-gray-300 border rounded-lg flex items-center w-full md:w-full"
            >
              <img
                src="/presention-chart.svg" // Replace with the actual path to your image
                alt="Graph Icon"
                className="h-5 w-5 mr-2" // Adjust size and spacing as needed
              />
              Generate Graph
            </button> */}

            {/* Dropdown */}
            <div ref={buttonStock} className="relative w-full md:w-full">
              {/* Dropdown Button */}
              <button
                onClick={() => setIsOpen(!isOpen)}
                className={`w-full md:w-full border font-medium border-gray-300 h-10 rounded-xl text-sm px-2 py-2 pr-10 flex justify-between items-center focus:outline-none ${
                  isOpen ? "bg-black text-white" : "bg-white text-black"
                }`}
              >
                <div className="flex items-center">
                  {isOpen ? (
                    <img
                      src="/filter-sort-white.svg"
                      alt="Filter Icon"
                      className="h-5 w-5 mr-2"
                    />
                  ) : (
                    <img
                      src="/filter-sort-black.svg"
                      alt="Filter Icon"
                      className="h-5 w-5 mr-2"
                    />
                  )}
                  Stocks
                </div>
              </button>

              {/* Dropdown List */}
              {isOpen && (
                <div
                  className="absolute left-0 mt-2 overflow-y-auto mb-5 w-full bg-white border rounded-md shadow-lg z-50"
                  style={{
                    maxHeight: "200px", // Optional: limit height
                  }}
                >
                  <div className="p-2">
                    <input
                      type="text"
                      value={searchStock}
                      onChange={(e) => setSearchStock(e.target.value)}
                      placeholder="Search..."
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                    />
                  </div>
                  {Allstock.filter((option) =>
                    option.label
                      .toLowerCase()
                      .includes(searchStock.toLowerCase())
                  ).map((option) => (
                    <div
                      key={option.value}
                      className="px-4 py-2 flex items-center cursor-pointer"
                    >
                      <input
                        type="checkbox"
                        checked={selectedStocks.includes(option.value)}
                        onChange={() => handleStockListChange(option)}
                        className="mr-2 custom-checkbox"
                      />
                      {option.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      {componentName != "saa-taa" && (
        <div>
          <div className="mb-4 mt-4 flex w-full justify-between flex-wrap">
            <div className="pr-4 flex-wrap items-center">
              <div className="flex">
                {["10Y", "5Y", "1Y", "3M", "1M"].map((filter, index) => (
                  <button
                    key={filter}
                    className={`px-3 py-1 shadow-md ${
                      filter === "1M" ? "rounded-r-xl" : ""
                    }
            ${filter === "10Y" ? "rounded-l-xl" : ""}
             
               ${
                 selectedFilter === filter
                   ? "bg-black text-white"
                   : "bg-white text-black"
               }`}
                    onClick={() => {
                      setSelectedFilter(filter);
                      hasGenerated.current = false;
                    }}
                  >
                    {filter}
                  </button>
                ))}
              </div>
            </div>
            {/* Flex container for image and performance text */}
            <div className="flex flex-row mt-4 md:mt-0   md:flex-row items-start ml-auto space-x-0 space-y-0">
              <div className="flex items-center">
                <img src="/blue-taa.svg" alt="taa" className="mr-1" />
                <span className="text-xs text-black">Total Price</span>
              </div>
              <div className="flex items-center pl-2">
                <img src="/red-saa.svg" alt="income-orange" className="mr-1" />
                <span className="text-xs text-black">Combined Indices</span>
              </div>
            </div>
          </div>
          {isLoadingGraph ? (
            <div className="shimmer-container-list mb-4 ">
              {/* Creating 5 rows of shimmer effect */}
              {[...Array(2)].map((_, rowIndex) => (
                <div key={rowIndex} className="shimmer-row-list">
                  {/* Creating 7 cells in each row for shimmer */}
                  {[...Array(5)].map((_, colIndex) => (
                    <div key={colIndex} className="shimmer-cell-list h-20">
                      <div className="shimmer-loader"></div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          ) : (
            <div>
              {graphData.length > 0 && (
                <MultiCharts
                  graphData={graphData}
                  combineData={combineData}
                  selectedFilter={selectedFilter}
                />
              )}
              <div className="mt-2 ml-2 flex flex-wrap text-xs flex justify-between font-semibold">
                <span className="mr-4 w-full mb-2 md:w-auto md:mb-0">
                  Return
                  <br />
                  (%)
                </span>

                {retrunedpercentages.map((year, index) => (
                  <div
                    key={year}
                    className={`text-left text-[#005A9C] border-b pb-2 border-black flex-1  md:w-1/10 min-w-[50px] ${
                      index === retrunedpercentages.length - 1
                        ? "ml-auto text-left lg:text-right md:text-right"
                        : ""
                    }`}
                    style={{ fontSize: "", textAlign: "" }}
                  >
                    {year}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
      {componentName == "saa-taa" && (
        <div>
          <div className="mb-4 mt-4 flex w-full justify-between flex-wrap">
            <div className="pr-4 flex-wrap items-center">
              <div className="flex">
                {["10Y", "5Y", "1Y", "3M", "1M"].map((filter, index) => (
                  <button
                    key={filter}
                    className={`px-3 py-1 shadow-md ${
                      filter === "1M" ? "rounded-r-xl" : ""
                    }
            ${filter === "10Y" ? "rounded-l-xl" : ""}
             
               ${
                 selectedFilter === filter
                   ? "bg-black text-white"
                   : "bg-white text-black"
               }`}
                    onClick={() => setSelectedFilter(filter)}
                  >
                    {filter}
                  </button>
                ))}
              </div>
            </div>
            {/* Flex container for image and performance text */}
            <div className="flex flex-row mt-2 md:mt-0   md:flex-row items-start ml-auto space-x-0 space-y-0">
              <div className="flex items-center">
                <img src="/blue-taa.svg" alt="taa" className="mr-1" />
                <span className="text-xs text-black">TAA</span>
              </div>
              <div className="flex items-center pl-2">
                <img src="/red-saa.svg" alt="income-orange" className="mr-1" />
                <span className="text-xs text-black">SAA</span>
              </div>
            </div>
          </div>
          <SaaTaaChart
            graphData={taaGraphData}
            selectedFilter={selectedFilter}
            isLoadingGraph={isLoadingGraph}
          />
        </div>
      )}
    </div>
  );
};

export default CustomGraph;
